import colorFunction from "css-color-function";
import { colorToHsl } from "utils/rgbToHsl";
import styles from "css/modules/colors.css";

let style;

// Define a list of custom transform functions. If a style is defined as `brandPrimary--border-color
// --[modifier-value]`, then we will run the property through `modifier()` function with the second
// paramter being `value`.
//
// For example, the border color of control buttons is the background color with a 95% opacity. We
// define the class `.brandSecondary--border-color--alpha-95`. The output will use the
// `brandSecondary` color and apply a `.95` opacity to that value for the `border-color`.
const customTransformFunctions = {
  alpha(input, alpha) {
    return colorFunction.convert(
      `color(${input} a(${parseFloat(alpha) / 100}))`,
    );
  },
};

function generateLoaderImageFilter(targetColor) {
  // Get the HSL values for the base color of the loading spinner
  const {
    luminosity: originalLoaderLuminosity,
    saturation: originalLoaderSaturaration,
    hue: originalLoaderHue,
  } = colorToHsl("#0187e8");

  // Calculate the HSL of the target color
  const {
    hue: targetHue,
    saturation: targetSaturation,
    luminosity: targetLuminosity,
  } = colorToHsl(targetColor);

  // Convert per http://stackoverflow.com/questions/29037023/how-to-calculate-required-hue-rotate-to-generate-specific-colour
  const newHue = targetHue - originalLoaderHue;
  const newSaturation = 100 + (originalLoaderSaturaration - targetSaturation);
  const newLuminosity = 100 + (targetLuminosity - originalLoaderLuminosity);

  // Return a value to use for the css
  return [
    `hue-rotate(${Math.round(newHue)}deg)`,
    `saturate(${Math.round(newSaturation) / 100})`,
    `brightness(${Math.round(newLuminosity) / 100})`,
  ].join(" ");
}

export default function updateCustomStylesheet(rules) {
  if (!style) {
    // Create a new `<style>` element if one does not exist
    style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
  }

  Object.entries(styles).forEach(([key, value]) => {
    const styleSelector = key.split("--")[0];
    const styleProperty = key.split("--")[1];
    const styleModifier = key.split("--")[2];

    let styleValue = rules[styleSelector];

    if (!styleValue) {
      return;
    }

    if (styleModifier) {
      const styleModifierFunctionName = styleModifier.split("-")[0];
      const styleModifierValue = styleModifier.split("-")[1];

      if (!customTransformFunctions[styleModifierFunctionName]) {
        throw new Error(
          `Custom color modifier found ${styleModifier} but no custom function exists`,
        );
      }
      styleValue = customTransformFunctions[styleModifierFunctionName](
        rules[styleSelector],
        styleModifierValue,
      );
    }
    if (rules[styleSelector]) {
      // Include `value` twice to make sure it has a higher specificity than the
      // original rule regardless of where the styles are injected in the DOM.
      const rule = `.${value}.${value} { ${styleProperty}: ${styleValue}; }`;
      style.innerHTML += rule;
    }
  });

  // Apply the filter to the spinner.
  if (rules.brandPrimary) {
    const spinnerFilter = generateLoaderImageFilter(rules.brandPrimary);

    style.innerHTML += `.vjs-loading-spinner:before {
        -webkit-filter: ${spinnerFilter};
        -ms-filter: ${spinnerFilter};
        -o-filter: ${spinnerFilter};
        -moz-filter: ${spinnerFilter};
        filter: ${spinnerFilter};
    }`;
  }
}
